import { styled } from '@mui/system'
import { IconButton, List, Box, Paper } from '@mui/material'

export const SettingsPopupContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  right: 0,
  zIndex: 1200,
  minWidth: 300,
  maxWidth: 400,
  marginTop: theme.spacing(1),

  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    minWidth: 'unset',
    maxWidth: 'unset',
    marginTop: 0,
    zIndex: 1300,
  },
}))

export const Backdrop = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 1200,
})

export const PopupContainer = styled(Paper)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: theme.spacing(1),
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  overflow: 'hidden',
  position: 'relative',

  [theme.breakpoints.down('md')]: {
    height: '100vh',
    borderRadius: 0,
    boxShadow: 'none',
    zIndex: 1300,
  },
}))

export const Header = styled(Box)<{ isMobile: boolean }>(
  ({ theme, isMobile }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: isMobile
      ? theme.palette.primary.main
      : theme.palette.grey[50],
    color: isMobile ? 'white' : 'inherit',

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2.5),
    },
  })
)

export const HeaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}))

export const Actions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}))

export const CloseButton = styled(IconButton)<{ isMobile: boolean }>(
  ({ theme, isMobile }) => ({
    color: isMobile ? 'white' : theme.palette.text.secondary,

    '&:hover': {
      color: isMobile ? 'rgba(255, 255, 255, 0.8)' : theme.palette.text.primary,
    },
  })
)

export const Content = styled(Box)(({ theme }) => ({
  padding: 0,
  maxHeight: 400,
  overflowY: 'auto',

  [theme.breakpoints.down('md')]: {
    maxHeight: 'calc(100vh - 100px)',
  },
}))

export const SettingsList = styled(List)({
  padding: 0,
  margin: 0,
})
